import React from "react";
import { useSelector } from "react-redux";

import {
  RideActionableCardSelector,
  RideRadioButton,
  RideGlInformationOutline,
} from "@rimac-seguros/ride-system-components";

import DynamicIcon from "@/components/atoms/DynamicIcon";
import { LIST_TYPE_BENEFICIARY, VE_LIST_TYPE_BENEFICIARY } from "@/constants/list-type-beneficiary";
import { APP_KEY_ENCRYPT } from "@/utils/awsConfig";
import { encrypt_AES256_2 } from "@/utils/CryptographyUtils";
import helpers from "@/utils/helpers";

import "./styles.scss";

const supportEmail = 'atencionalcliente@rimac.com.pe';

export const SectionBeneficiaries = ({
  register,
  errors,
  className,
  isVE = false,
}) => {
  const { userData } = useSelector((state) => state.vida);
  const beneficiaryTypes = isVE ? VE_LIST_TYPE_BENEFICIARY : LIST_TYPE_BENEFICIARY;

  const handleClickLink = (link) => {
    if (userData.indPrevPageApp) {
      const email = link.replace("mailto:", "");
      const message = `EMBEDDED-APP-HIPERVINCULO : {"accion": "EMAIL", "valor": "${email}", "mensaje": ""}`;
      const encryptedMessage = encrypt_AES256_2(message, APP_KEY_ENCRYPT);
      return helpers.sendMessageToApp(encryptedMessage);
    }
    window.open(link, "_blank", "noopener noreferrer");
  };

  return (
    <div className={`section-beneficiaries ${className}`}>
      <>
        <h3>Tus beneficiarios</h3>
        <div className="section-beneficiaries_type">
          {beneficiaryTypes.map((option) => {
            return (
              <RideActionableCardSelector
                key={option.key}
                borderRadiusSize="small"
                paddingSize="large"
                control={
                  <RideRadioButton
                    value={option.key}
                    {...register("beneficiaryType", { required: true })}
                    error={errors?.beneficiaryType}
                  />
                }
                className="h-full"
              >
                <div className="section-beneficiaries_type--card">
                  <DynamicIcon icon={option.icon} size="small" />
                  <h4 className="w-full lg:w-32">{option.title}</h4>
                  <p>{option.description}</p>
                </div>
              </RideActionableCardSelector>
            );
          })}
        </div>

        <div
          className={`flex gap-ride-gl-spacing-large rounded-ride-sys-border-radius-container-large py-ride-gl-spacing-2xlarge px-ride-gl-spacing-xlarge ${
            isVE
              ? "bg-ride-sys-color-surface-moderate mt-ride-gl-spacing-5xlarge"
              : "bg-ride-sys-color-surface-subtle mt-ride-gl-spacing-4xlarge"
          }`}
        >
          <RideGlInformationOutline size="large" />
          <p className={`ride-sys-text-paragraph-small-default ${isVE ? "text-ride-sys-color-text-extreme" : "text-ride-sys-color-text-medium"}`}>
            Asegúrate de ingresar los datos correctos para comunicarnos con tus
            beneficiarios. Si no tienes la información, te recomendamos
            seleccionar “Herederos legales” para continuar. Podrás modificar a
            tus beneficiarios en cualquier momento enviando un correo a{" "}
            {
              isVE ?
                <b>{supportEmail}</b> :
                <button
                  type="button"
                  className="ride-sys-text-paragraph-small-underline cursor-pointer"
                  onClick={() =>
                    handleClickLink(`mailto:${supportEmail}`)
                  }
                >
                  {supportEmail}
                </button>
            }
          </p>
        </div>
      </>
    </div>
  );
};
